import { render, staticRenderFns } from "./PublicCourseCard.vue?vue&type=template&id=711b35aa&scoped=true"
import script from "./PublicCourseCard.vue?vue&type=script&lang=js"
export * from "./PublicCourseCard.vue?vue&type=script&lang=js"
import style0 from "./PublicCourseCard.vue?vue&type=style&index=0&id=711b35aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711b35aa",
  null
  
)

export default component.exports